import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { faCheckCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { XOS_GREEN } from '../constants/colors';

const Container = styled.div`
  display: flex;
  padding-bottom: 30px; 
  justify-content: center;
  width: 100%;
`;

function WebsocketLoadingSpinner(props) {
  const { isLoading } = props;
  return (
    <Container id="GeneralSettings.ApplicationModal.LoadingSpinner">
      { isLoading ? <FontAwesomeIcon icon={faSpinner} size="4x" spin />
        : <FontAwesomeIcon icon={faCheckCircle} size="4x" color={XOS_GREEN} />
    }
    </Container>
  );
}

WebsocketLoadingSpinner.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

export default WebsocketLoadingSpinner;
